import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { Box, Checkbox, Text, Search } from '@wix/design-system';
import { WidgetLayout } from '../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { CardLayout } from '../../CommonWidgets/shared/CardLayout/CardLayout';
import { Picture } from '../../CommonWidgets/shared/Picture/Picture';
export const ApiSelectionMultiSelectWidget = _ref => {
  var _data$secondaryButton, _data$primaryButton, _data$searchable, _data$scrollable;
  let {
    data,
    context
  } = _ref;
  const [filter, setFilter] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(API_SELECTION_MULTI_SELECT_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const handleCheckboxClick = (value, label) => {
    let shouldAdd;
    setSelectedValues(prev => {
      shouldAdd = !prev.includes(value);
      return shouldAdd ? [...prev, value] : prev.filter(v => v !== value);
    });
    const onWidgetActionData = {
      action: shouldAdd ? 'checkbox_select' : 'checkbox_unselect',
      value: {
        value,
        label
      }
    };
    context.onWidgetAction(API_SELECTION_MULTI_SELECT_WIDGET, onWidgetActionData, data.text);
  };
  const cards = (data.options ?? []).filter(_ref2 => {
    let {
      title,
      text
    } = _ref2;
    return matchFilter(title, filter) || matchFilter(text, filter);
  }).map(_ref3 => {
    let {
      picture,
      title,
      text,
      value
    } = _ref3;
    return /*#__PURE__*/React.createElement(CardLayout, {
      key: value
    }, (picture == null ? void 0 : picture.url) && /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
      aspectRatio: "3/2"
    })), /*#__PURE__*/React.createElement(Checkbox, {
      id: value,
      checked: selectedValues.includes(value),
      onChange: () => {
        handleCheckboxClick(value, title);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        transform: 'translateY(-1px)'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "bold"
    }, title))), text && /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, text));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: selectedValues,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    disabled: false,
    onEnableControls: () => {}
  }, ((_data$searchable = data.searchable) == null ? void 0 : _data$searchable.enable) && /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Search, {
    placeholder: data.searchable.placeholder || 'Search',
    size: "small",
    onChange: e => setFilter(e.target.value),
    border: "bottomLine",
    value: filter
  })), !!cards.length && ((_data$scrollable = data.scrollable) != null && _data$scrollable.enable ? /*#__PURE__*/React.createElement(Box, {
    maxHeight: data.scrollable.maxHeight,
    direction: "vertical",
    overflow: "auto",
    gap: 1
  }, cards) : cards));
};
export const API_SELECTION_MULTI_SELECT_WIDGET = 'API_SELECTION_MULTI_SELECT_WIDGET';
function matchFilter(text, filter) {
  return text == null ? void 0 : text.toLowerCase().includes(filter.toLowerCase());
}
//# sourceMappingURL=ApiSelection.js.map